const isRepositoryName = (input) => {
  return /^[a-zA-Z0-9][-a-zA-Z0-9]{2,}[a-zA-Z0-9]$/.test(input);
};
export {
  isRepositoryName
};
//# sourceMappingURL=isRepositoryName.js.map
